import { render, staticRenderFns } from "./MainInspection.vue?vue&type=template&id=040f3dd6&scoped=true&"
import script from "./MainInspection.vue?vue&type=script&lang=ts&"
export * from "./MainInspection.vue?vue&type=script&lang=ts&"
import style0 from "./MainInspection.vue?vue&type=style&index=0&id=040f3dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f3dd6",
  null
  
)

export default component.exports